module.exports = __webpack_public_path__ + "img/headerText.f39d1639.png";